// extracted by mini-css-extract-plugin
export default {"legalSection":"legal_legalSection__4vbXQ","container":"legal_container__NyWpS","navContainer":"legal_navContainer__wVDY+","articleContainer":"legal_articleContainer__pSFB+"};